import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "panel" ]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }

  close() {
    this.panelTarget.classList.add("hidden")
  }
}
